import React, { Component } from "react";
import styled from 'styled-components';

class Divider extends Component {
  render() {
    return (
      <DividerStyled />
    );
  }
}

const DividerStyled = styled.div`
  width: 100%;
  height: 1px;
  border-top: 1px solid #8C8C8C;
`;

export default Divider;